import axios from "axios";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import bgImg from "../../assets/background.png";

export const UserLogin = (props) => {
  const signin = props.signin;
  const { register, handleSubmit, reset } = useForm();
  const navigate = useNavigate();

  const submit = (data) => {
    console.log("submitting form");
    console.log(data);
    axios
      .post("/api/auth/login", data)
      .then((res) => {
        console.log(res.data);
        const tokenToSet = res.data ? res.data.token : "";
        sessionStorage.setItem(
          "userToken",
          tokenToSet.substring(7, tokenToSet.length)
        );
        sessionStorage.setItem("role", res.data.role);

        signin();
        console.log("gotten data");

        navigate("/dashboard");
      })
      .catch((err) => {
        alert("user not found....");
        navigate("/");
      });
    reset();
  };



  useEffect(() => {
    sessionStorage.clear();
  }, []);

  return (
    <div>
      <main className="main-content mt-0">
        <div
          className="page-header align-items-start min-vh-100"
          style={{
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            width: "100vw",
            height: "100vh",
            backgroundImage: `url(${bgImg})`,
          }}
        >
          <span className="" />
          <div className="container my-auto" style={{ display: "flex", justifyContent: "flex-end" }}>
            <div className="row justify-content-end w-100 h-100">
              <div className="col-lg-4 col-md-8 ">
                <div className="card z-index-0 fadeIn3 fadeInBottom">
                  <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                    <div className="bg-gradient-info shadow-info border-radius-lg py-3 pe-1">
                      <h4 className="text-white font-weight-bolder text-center mt-2 mb-0">
                        Sign in
                      </h4>
                    </div>
                  </div>
                  <div className="card-body">
                    <form onSubmit={handleSubmit(submit)}>
                      <div className="input-group input-group-outline my-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Username"
                          {...register("username")}
                        />
                      </div>
                      <div className="input-group input-group-outline mb-3">
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Password"
                          {...register("password")}
                        />
                      </div>
                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn bg-gradient-info w-100 my-4 mb-2"
                        >
                          Sign in
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};